import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { KeyValue, Row, Col, Accordion, } from '@folio/stripes/components';
import { ProposalStatus } from '../../types/api';
import useUserName from '../../hooks/useUserName';
import { formatSourceSystem } from '../../utils/formatSourceSystem';
import { formatUserWithSigla } from '../../utils/formatUserWithSigla';
import { recordDisplayId } from '../../utils/recordDisplayId';
import { proposalPath } from '../../routes/Proposals';
/**
 * Displays record metadata (IDs, source, version, audit timestamps).
 * User UUIDs are resolved to display names via mod-czna-users, each followed by the sigla
 * of the user's current organization when there is one (CZNA-1616) — which institution
 * the record came from is what a supervisor needs to know whom to contact.
 */
var MetadataSection = function (_a) {
    var _b;
    var record = _a.record;
    var createdBy = useUserName(record.createdBy);
    var updatedBy = useUserName(record.updatedBy);
    var approvedBy = useUserName(record.approvedBy);
    var createdByName = formatUserWithSigla(createdBy.name, createdBy.sigla);
    var updatedByName = formatUserWithSigla(updatedBy.name, updatedBy.sigla);
    var approvedByName = formatUserWithSigla(approvedBy.name, approvedBy.sigla);
    var intl = useIntl();
    var formatDateTime = function (value) {
        if (!value)
            return null;
        var date = intl.formatDate(value, { day: '2-digit', month: '2-digit', year: 'numeric' });
        var time = intl.formatTime(value, { hour: '2-digit', minute: '2-digit' });
        return "".concat(date, " ").concat(time);
    };
    return (React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata" }) },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.authorityId" }), value: recordDisplayId(record) }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.sourceSystem" }), value: formatSourceSystem(record.sourceSystem) })),
            record.sourceIdentifier && (React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.sourceIdentifier" }), value: record.sourceIdentifier })))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.version" }), value: record.version }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.createdBy" }), value: createdByName })),
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.createdAt" }), value: formatDateTime(record.createdAt) }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.updatedBy" }), value: updatedByName })),
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.updatedAt" }), value: formatDateTime(record.updatedAt) }))),
        record.approvedBy && (React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.approvedBy" }), value: approvedByName })),
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.approvedAt" }), value: formatDateTime(record.approvedAt) })))),
        record.sourceProposalId && (React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.metadata.sourceProposal" }), value: (React.createElement(Link, { to: proposalPath(ProposalStatus.APPROVED, record.sourceProposalId) }, (_b = record.sourceProposalAuthorityId) !== null && _b !== void 0 ? _b : record.sourceProposalId)) }))))));
};
export default MetadataSection;
